import axios from 'axios';

export default class VaccinationToolHandler {
    constructor({ contextPath }) {
        this.contextPath = contextPath;
    }

    search(country) {
        if (!country) {
            return Promise.reject(new Error('Missing required parameter country'));
        }

        return axios
            .get(`${this.contextPath}/api/vaccinations`, {
                params: {
                    country,
                },
            })
            .then(response => response.data);
    }

    getCountries() {
        return axios
            .get(`${this.contextPath}/api/vaccinations/vaccination-countries`)
            .then(response => response.data);
    }
}



// WEBPACK FOOTER //
// ./src/frontend/apps/VaccinationTool/VaccinationToolHandler.js